import {
  toCurrency,
  toCurrencyTruncated,
  toFactor,
  toPercentage,
} from '@/utilities/formatting';

export const formatterFactor = (value: number | null) =>
  value !== null && value !== 0 ? toFactor(value, 1) : 'n/a';

export const formatCurrency = (amount = 0, currencyISO?: string) => {
  if (amount > 99999) {
    return toCurrencyTruncated(amount, 1, currencyISO);
  }
  return toCurrency(amount, 2, currencyISO);
};

export const formatterPercentage = (
  value: number | null,
  significance?: number
) => (value !== null ? toPercentage(value, significance || 1) : 'n/a');
